import React from "react";
import { TextField, Box } from "@mui/material";
import { useTranslation } from "react-i18next";

interface ProductPriceInputProps {
    value: number;
    onChange: (value: number) => void;
    isEditable: boolean;
}

const ProductPriceInput: React.FC<ProductPriceInputProps> = ({ value, onChange, isEditable }) => {
    const { t } = useTranslation();
    const [inputValue, setInputValue] = React.useState(value === 0 ? "" : String(value));

    React.useEffect(() => {
        const numericInput = inputValue === "" ? 0 : Number(inputValue);
        if (numericInput !== value) {
            setInputValue(value === 0 ? "" : String(value));
        }
    }, [value]);

    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const raw = e.target.value;
        if (raw === "") {
            setInputValue("");
            onChange(0);
            return;
        }
        if (/^\d*\.?\d{0,2}$/.test(raw)) {
            setInputValue(raw);
            if (!raw.endsWith(".")) {
                onChange(Number(raw));
            }
        }
        // invalid input: don't update inputValue so controlled input reverts it
    };

    const handlePaste = (e: React.ClipboardEvent<HTMLInputElement>) => {
        const pasted = e.clipboardData.getData("text");
        if (!/^\d*\.?\d*$/.test(pasted)) {
            e.preventDefault();
        }
    };

    return (
        <Box sx={{ px: 2.5, mt: 2 }}>
            <TextField
                fullWidth
                label={t("amount")}
                type="text"
                inputMode="decimal"
                value={inputValue}
                onChange={handleChange}
                onPaste={handlePaste}
                disabled={!isEditable}
                variant="outlined"
                InputLabelProps={{ shrink: inputValue !== "" || !isEditable }}
                InputProps={{
                    sx: { borderRadius: 2 }
                }}
            />
        </Box>
    );
};

export default ProductPriceInput;
